import Blockly from 'blockly'

class CustomCategory extends Blockly.ToolboxCategory {
  /**
   * Constructor for a custom category.
   * @override
   */
  constructor(categoryDef: Blockly.utils.toolbox.CategoryInfo, toolbox: Blockly.IToolbox, opt_parent?: Blockly.ICollapsibleToolboxItem) {
    super(categoryDef, toolbox, opt_parent)
  }

  /**
   * Adds the colour to the toolbox.
   * This is called on category creation and whenever the theme changes.
   * @override
   */
  addColourBorder_(colour: string): void {
    // prettier-ignore
    (this.rowDiv_ as HTMLElement).style.backgroundColor = colour
  }

  setSelected(isSelected: boolean): void {
    const rowDom = document.getElementsByClassName('blocklyFlyout')[1] as HTMLElement
    rowDom.style.border = '8px solid ' + this.colour_
    rowDom.style.borderRadius = '0px 10px 10px 0px'
    rowDom.style.backgroundColor = '#ffffff'
    const childRowDom = rowDom.querySelector('.blocklyFlyoutBackground') as HTMLElement
    childRowDom.style.fill = '#ffffff'
    Blockly.utils.aria.setState(/** @type {!Element} */ this.htmlDiv_, Blockly.utils.aria.State.SELECTED, isSelected)
  }
}

export default CustomCategory
